module.exports = "export default function ({Plugin, types: t}) {\r\n  return new Plugin('ast-transform', {\r\n    visitor: {\r\n      Identifier(node) {\r\n        return t.identifier(node.name.split('').reverse().join(''));\r\n      }\r\n    }\r\n  });\r\n}\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/parsers/js/transformers/babel/codeExample.txt
 ** module id = ./src/parsers/js/transformers/babel/codeExample.txt
 ** module chunks = 0
 **/